import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "./views/HomeView.vue";
import ProductDetailPage from "./views/ProductDetailPage.vue";
import PricingPage from "./views/PricingPage.vue";
import HelpPage from "./views/HelpPage.vue";
import AboutPage from "./views/AboutPage.vue";
import CasePage from "./views/CasePage.vue";
import { PRODUCT_SLUGS } from "@/mock/defaultData";

Vue.use(VueRouter);

const routes = [
  { path: "/", name: "home", component: HomeView },
  {
    path: "/products",
    redirect: { name: "productDetail", params: { slug: "oms" } }
  },
  {
    path: "/products/:slug",
    name: "productDetail",
    component: ProductDetailPage,
    beforeEnter(to, from, next) {
      const s = String(to.params.slug || "").toLowerCase();
      if (!PRODUCT_SLUGS.includes(s)) {
        next({ name: "productDetail", params: { slug: "oms" }, replace: true });
      } else next();
    }
  },
  { path: "/pricing", name: "pricing", component: PricingPage },
  { path: "/help", name: "help", component: HelpPage },
  { path: "/cases", name: "cases", component: CasePage },
  { path: "/about", name: "about", component: AboutPage },
  { path: "*", redirect: "/" }
];

const router = new VueRouter({
  mode: "hash",
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  }
});

export default router;
